import { useAuth } from '../utils/auth';

export function useApiResourceDefinition() {

  const auth = useAuth();
  const resource = auth.apiBaseUrl + '/resource';

  const getData = async function (filter, paginationModel, filterModel, sortModel) {

    paginationModel = paginationModel || {page : 0, pageSize : 25};
    let page = paginationModel.page || 0 ;
    let pageSize =  paginationModel.pageSize || 25;
    
    let aFilters = [], aSorters = [];    
    let userFilters = [], userSorters = [] ;

    filterModel = filterModel || {items : []};
    sortModel = sortModel || [];    
    
    if (filterModel.items.length>0) {      
      filterModel.items.forEach(element => {
        userFilters.push({
          property : element.field,
          operator : element.operator,
          value : element.value
        });
      });      
    }

    if (sortModel.length>0) {      
      sortModel.forEach(element => {
        userSorters.push({
          property : element.field,
          direction : element.sort
        });
      });      
    }

    // active
    if (filter==='inuse') {
      aFilters = [{property:"red_is_active",value:1,operator:"="}];
      aSorters = [{property:"red_id", direction: 'ASC'}];
    }

    // active
    if (filter==='notinuse') {
      aFilters = [{property:"red_is_active",value:0,operator:"="}];
      aSorters = [{property:"red_id", direction: 'ASC'}];
    }


    if (userFilters.length>0) {
      aFilters = aFilters.concat(userFilters);
    }

    return fetch(resource  + '?start=' + (page * pageSize) + '&count=' + pageSize + '&filters=' + JSON.stringify(aFilters) + '&sorters=' + JSON.stringify(aSorters), {
      signal : AbortSignal.timeout(30000),
      headers: {
        "Content-Type" : "application/json",
        "Authorization": "Bearer " + (auth.user ? auth.user.token : "")                    
      },
      method: "GET"
    }).then((res) => {
      if (res.ok) {                
        return res.json();
      } else if (res.status===401) {
        return {          
          returnCode : -401,
          returnMsg : "Acces non autorisé, vous devez vous connecter" //res.statusText
        }  ;        
      } else {  
        return {          
          returnCode : -2,
          returnMsg : res.statusText
        }  ;
      }
    }).catch(error => {
      return {          
        returnCode : -500,
        returnMsg : (error.response || error.request || error.message)
      }  ;      
    })
  };

  const updateData = async function (data) {
    return fetch(resource + '/' + data.red_id, {
      signal : AbortSignal.timeout(30000),
      headers: {
        "Content-Type" : "application/json",
        "Authorization": "Bearer " + (auth.user ? auth.user.token : "")                    
      },
      method: "PUT",
      body  : JSON.stringify(data)
    }).then((res) => {
      if (res.ok) {                
        return res.json();
      } else if (res.status===401) {
        return {          
          returnCode : -401,
          returnMsg : "Acces non autorisé, vous devez vous connecter" //res.statusText
        }  ;        
      } else {  
        return {          
          returnCode : -2,
          returnMsg : res.statusText
        }  ;
      }     
    }).catch(error => {
      return {          
        returnCode : -500,
        returnMsg : (error.response || error.request || error.message)
      }  ;       
    })
  };

  return {
    getData
    ,updateData
  };
}
